import { render, staticRenderFns } from "./MergeCate02Child.vue?vue&type=template&id=d7ecfc0c"
import script from "./MergeCate02Child.vue?vue&type=script&lang=js"
export * from "./MergeCate02Child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports